<template>
	<el-dialog v-model="innerVisible"  :close-on-click-modal="false" :title="title" width="92%"  custom-class="zero-padding-modal" @open="openInit" @opened="openedInit" @closed="closeDeal">
		<template #default>			
			<div class="assemble-edit-modal-content">
				<el-form :model="addForm" label-width="130px" ref="dialogRef" :rules="formRules" style="margin:20px 20px 0 0;margin-top: 20px;" >
					<el-row>
						<el-col :span="6">
							<el-form-item label="部门编号:" prop="departmentNumber">
								<el-select v-model="addForm.departmentNumber" clearable allow-create filterable placeholder="请选择部门编号" size="large" style="width: 100%;">
									<el-option v-for="item in departmentData" :key="item.label" :label="item.mE002" :value="item.mE001" />
								</el-select>
							</el-form-item>
						</el-col> 
						<el-col :span="6">
							<el-form-item label="转出项目编号:" prop="transferToIssue">
								<el-select
									style="width: 100%;"
									v-model="addForm.transferToIssue"							
									filterable
									remote
									reserve-keyword
									placeholder="请输入项目编号"
									remote-show-suffix
									:remote-method="outProjectRemoteMethod"
									:loading="outProjectloading"
								>
									<el-option
									v-for="(item,index) in outProjectOptions"
									:key="index"
									:label="item"
									:value="item"
									/>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="转入项目编号:" prop="projectCode">
								<el-select
									style="width: 100%;"
									v-model="addForm.projectCode"							
									filterable
									remote
									reserve-keyword
									placeholder="请输入项目编号"
									remote-show-suffix
									:remote-method="projectRemoteMethod"
									:loading="projectloading"
								>
									<el-option
									v-for="(item,index) in projectOptions"
									:key="index"
									:label="item"
									:value="item"
									/>
								</el-select>
							</el-form-item>
						</el-col>
						
						<el-col :span="6">
							<el-form-item label="备注:" prop="remarks">
								<el-input v-model="addForm.remarks" clearable placeholder="请输入备注" />
							</el-form-item>
						</el-col>                                 
					</el-row>
				</el-form>
				<div class="modal-content-top" style="display: flex;justify-content: space-between;">
					<div style="display: flex;">
						<div><el-button type="primary" icon="el-icon-plus" @click="onOpenChooseModal">添加物料</el-button></div>	           
					</div>
				</div>	
				<div class="modal-content-list">
					<div class="list-padding">
						<el-table :data="list" border row-key="tableKey" @scroll="handleScroll" ref="showMaterial"
							height="500" 
							v-loading="isLoading"  
							element-loading-text="拼命加载中..."
							element-loading-spinner="el-icon-loading"
							element-loading-background="rgba(0, 0, 0, 0.8)">
							<el-table-column label="序号" align="center" width="60">
								<template #default="scope">{{scope.$index+1}}</template>
							</el-table-column>
							<el-table-column label="品号" prop="code" align="center" width="" :sortable="true"/>
							<el-table-column label="品名" prop="name" align="center" width="250"/>
							<el-table-column label="规格型号" prop="specificationModel" align="center" width="350"/>
							<el-table-column label="单位" prop="unit" align="center" width="60"/>							
							<el-table-column label="入库数" width="" align="center">
							  <template #default="scope">
									<el-input-number v-model="scope.row.orderQuantity" :min="0" :max="scope.row.currentQuantity" size="small" />
							  </template>
							</el-table-column>
							
							<el-table-column label="操作" width="80" align="center">
							  <template #default="scope">
							    <el-button type="danger" size="small" @click="onDel(scope.$index)">删除</el-button>
							  </template>
							</el-table-column>
						</el-table>
					</div>
				</div>				
			</div>			
			<choose-material-modal v-model:visible="chooseVisieble" :projectCode="addForm.projectCode" @callback="chooseModalCallback"  />
			<choose-material-modal v-model:visible="chooseVisieble" :projectCode="addForm.transferToIssue" @callback="chooseModalCallback"  />
		</template>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="onBtnClose">取 消</el-button>
				<el-button type="primary" :disabled="list.length===0 && dialogVisible" @click="confirm">提 交</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script setup>
import { defineEmits, ref, computed,watch, toRefs,reactive,nextTick,onMounted,onBeforeUnmount } from 'vue'	
import ChooseMaterialModal from './ChooseMaterialModal.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { AddTransdepartment,GetCMSMQ,GetLocationCode,GetProjectCode,InsertTransferOrder,AddTransferOrderDetails,TransferOrderDetails,
	UpdateTransferOrderDetails,AddInsertTransferOrder
 } from '@/service/main/invoices/allocateOrder';
import { localStatus } from '../../switchCase'
import ElUpload from "element-plus/lib/el-upload";
const emits = defineEmits(['update:visible','loadInitData','callback'])
import { exportExcel } from "@/utils/exportExcel";
const props = defineProps({
	visible:{
		type:Boolean,
		default:false
	},
	editDetails:{
		type:Array,
		default:()=>{
			return []
		}
	},
	mainEdit:{
		type:Object,
		default:()=>{
			return {}
		}
	},	
	type:{
		type:String,
		default:'info'
	},
	orderId:{
		type:[String,Number],
		default:''
	}
})
//////////////////////////////////
const formRules = {
    // orderCategory: [{ required: true, message: "调拨但别不能为空", trigger: "blur" }],
    departmentNumber: [{ required: true, message: "部门编号不能为空", trigger: "blur" }],
    projectCode: [{ required: true, message: "转入项目编号不能为空", trigger: "blur" }],
    transferToIssue: [{ required: true, message: "转出项目编号不能为空", trigger: "blur" }],
    // remarks: [{ required: true, message: "发货日期不能为空", trigger: "blur" }],
}
// 编辑送货预约窗口中表单数据绑定
const addForm = ref({
    id: 0,
	orderCategory:"",//单别
    departmentNumber: "",//部门编号
    projectCode: "",//项目编号
    remarks: "",
	transferToIssue:"",//转出项目编号
})
const departmentData = ref([])
const getStatusOption = function(){
	AddTransdepartment().then((d)=>{
		departmentData.value = d.data || []
	}).catch((err)=>{
		console.log(err)
	})
}
getStatusOption()
const CMSMQData = ref([])
const getStatusOptions = function(){
	GetCMSMQ().then((d)=>{
		CMSMQData.value = d.data || []
	}).catch((err)=>{
		console.log(err)
	})
}
getStatusOptions()
const { visible, type, orderId,editDetails,mainEdit } = toRefs(props)

const innerVisible = ref(false)
const title = ref('')
const chooseVisieble = ref(false)
const list = ref([])

watch(
	visible,
	function(newVal){
		if (innerVisible.value!==newVal) {
			innerVisible.value = newVal
		}
	},
	{immediate:true}
)
watch(innerVisible,function(newVal){
	if (visible.value!==newVal) {
		emits('update:visible',newVal)
	}
})

const closeDeal = function(){
	selfClose()
}

const onBtnClose = function(){
	selfClose()
}

const selfClose = function(){
	innerVisible.value = false
	addForm.value.orderCategory= ""//项目编号
    addForm.value.departmentNumber = ""
    addForm.value.projectCode = ""
    addForm.value.transferToIssue = ""
    addForm.value.remarks = ""
	addForm.value = {}
	list.value = []
}

const checkBeforeSubmit = function() {
	let n = -1
	for (let i=0;i<list.value.length;i++) {
		if (list.value[i].orderQuantity<=0) {
			n = i;
			break
		}
	} 
	if (n===-1) {
		return true
	} else {
		ElMessageBox.alert(`第${n+1}笔物料出库数错误。`,'系统提示')
		return false
	}
}
const dialogRef = ref()
const dialogVisible = ref(false)
const confirm = function(){
	dialogRef.value.validate((valid) => {
        if (valid) {
			dialogVisible.value = true
            let f = checkBeforeSubmit()
			if (!f) return flase		
			addForm.value.transferOrderDetailsList = list.value
			console.log('addForm',addForm.value)
			if (type.value==='modify') {
				UpdateTransferOrderDetails(addForm.value).then((res) => {
						ElMessage.success("操作成功")
						selfClose()
						emits('callback')
						dialogVisible.value = false
					}).catch(()=>{
						dialogVisible.value = false
						// callback && callback(false)
					})
				} else {
					AddInsertTransferOrder(addForm.value).then((res) => {
						ElMessage.success("操作成功")
						selfClose()
						emits('callback')
						dialogVisible.value = false
					}).catch(()=>{
						dialogVisible.value = false
						// callback && callback(false)
					})
				}
			
        } 
    })
	
}
const openedInit = function(){	
	list.value = []	
	nextTick(() => {
		title.value = type.value==='modify' ? '修改单据' : '新增单据';
		if ( type.value==='modify') {
			pagination.id = mainEdit.value.id
			TransferOrderDetails(pagination).then((res) => {
				list.value = res.data.wareTransferOrderDetails.rows
				addForm.value = res.data
				totol.value = res.data.wareTransferOrderDetails.totalRows
			}).catch(()=>{
				// callback && callback(false)
			})			
			// addForm.value = JSON.parse(JSON.stringify(mainEdit.value));
		}
	});
}
const isLoading = ref(false)
const pagination = {
  PageNo: 1,
  PageSize: 50,
  id:mainEdit.value.id
};
const totol = ref(0)
const modifyInit = function(){	
	pagination.id = mainEdit.value.id
	TransferOrderDetails(pagination).then((res) => {
		list.value = res.data.wareTransferOrderDetails.rows
		// totol.value = res.data.wareTransferOrderDetails.rows
		addForm.value = res.data
		// totol.value = res.data.wareTransferOrderDetails.totalRows
		isLoading.value = false
	}).catch(()=>{
		// callback && callback(false)
		isLoading.value = false
	})
}

const handleScroll = ({ target }) => {
  
  // console.log('target',target)
  const { scrollTop, clientHeight, scrollHeight } = target;
  
  // 当滚动到底部时加载更多
//   if()
console.log('pagination.PageSize',pagination.PageSize)
console.log('totol.value',totol.value)
  if (scrollTop + clientHeight >= scrollHeight-10 && pagination.PageSize <=totol.value) {
 
    isLoading.value = true
    pagination.PageSize = pagination.PageSize + 50
    modifyInit();
  }
}
const openInit = function(){
	// setTitle()
}
const setTitle = function(){
	if (type.value==='modify') {
		title.value = '修改单据'
	} else {
		title.value = '新增单据'
	}
}
const getModifyInitData = function(){
	emits('loadInitData',{id:orderId.value,PageNo:1,PageSize:9999},function(f,d){
		if (f) {
			list.value = (d.data.rows || []).map((obj,index)=>{
				obj.tableKey = 'edit-' + new Date().getTime() + '-' + index
				return obj
			})
		}
	})
}

const onOpenChooseModal = function(){
	chooseVisieble.value = true
}

const chooseModalCallback = function(arr){
	if (list.value.length===0) {
		list.value = arr.map((obj,index)=>{
			obj.tableKey = 'add-' + new Date().getTime() + '-' + index
			obj.orderQuantity = obj.outNum
			return obj
		})
	} else {
		addChooseMaterials(arr)
	}
}

const addChooseMaterials = function(arr) {
	let c = 0
	arr.forEach((arritem,arri)=>{
		if (checkMaterialExist(arritem)) {
			c++
		} else {
			arritem.tableKey = 'add-' + new Date().getTime() + '-' + arri
			arritem.orderQuantity = arritem.outNum
			list.value.push(arritem)
		}
	})
	
	if (c>0) {
		ElMessageBox.alert(`有${c}个物料已存在，未加入。`,'系统提示')
	}
}

const checkMaterialExist = function(obj) {
	let res = false
	for (let i=0;i<list.value.length;i++) {
		if (list.value[i].code===obj.code && list.value[i].locationCode===obj.locationCode) {
			res = true
			break
		}
	}
	return res
}

const onDel = function(index) {
	list.value.splice(index,1)
}

//项目号模糊查询
const projectloading = ref(false)
const projectOptions = ref([])
const projectRemoteMethod = function(query){
	projectOptions.value = []
	if (query!==null&&query!==undefined&&query.length>2) {
		projectloading.value = true	
		GetProjectCode({ProjectCode:query}).then((res) => {
			// console.log('res',res)
			projectloading.value = false
			projectOptions.value = res.data
		}).catch(()=>{
			projectloading.value = false
		})
	} else {
		projectOptions.value = []
	}
}

//转出项目号模糊查询
const outProjectloading = ref(false)
const outProjectOptions = ref([])
const outProjectRemoteMethod = function(query){
	outProjectOptions.value = []
	if (query!==null&&query!==undefined&&query.length>2) {
		outProjectloading.value = true	
		GetProjectCode({ProjectCode:query}).then((res) => {
			// console.log('res',res)
			outProjectloading.value = false
			outProjectOptions.value = res.data
		}).catch(()=>{
			outProjectloading.value = false
		})
	} else {
		outProjectOptions.value = []
	}
}

//转入库位模糊查询
const loading = ref(false)
const options = ref([])
const remoteMethod = function(query){
	options.value = []
	if (query.length>2) {
		loading.value = true	
		GetLocationCode({LocationCode:query}).then((res) => {
			// console.log('res',res)
			loading.value = false
			options.value = res.data
		}).catch(()=>{
			loading.value = false
		})
	} else {
		options.value = []
	}
}
//转入库位
const remoteMethods = function(query){
	options.value = []
	if (query.length>2) {
		loading.value = true	
		GetLocationCode({LocationCode:query}).then((res) => {
			// console.log('res',res)
			loading.value = false
			options.value = res.data
		}).catch(()=>{
			loading.value = false
		})
	} else {
		options.value = []
	}
}
//导入
import local from '@/utils/cache'
import {useStore} from '@/store'
// const props = defineProps<{apiUrl: string}>();
const actionUrl = computed(() => local.getCache('host')=='192.168.150.23'?'http://192.168.150.23:9085/api/TransferOrder/ImportMaterial':'http://222.71.245.114:9085/api/TransferOrder/ImportMaterial')
const store = useStore();
const token = computed(() => store.state.login.token)

const headerObj = ref({
  Authorization: `Bearer ${token.value}`
});
// const uploadRef = ref<InstanceType<typeof ElUpload>>();
const uploadRef = ref();
const fileList = ref([]);
const submitUpload = () => {
  	// uploadRef.value!.submit();
	  uploadRef.value.submit()
};
const handleRemove = (file, fileList) => {
  // console.log('移除成功')
};
const handleSuccess = (response, file) => {
	console.log('fileList',fileList)
  if(response.code == 200) {
    console.log('response',response)
	response.data.forEach(item=>{
		item.orderQuantity = item.currentQuantity
		list.value.push(item)
	})
    
  }else {
    ElMessage.error(`导入失败${response.code}:${response.message}`)
  }

};
//
const modelList = ref([
	{code:'2200131272',projectCode:'AT22021',locationCode:'L02',currentQuantity:1},
	{code:'2200131228',projectCode:'AT22021',locationCode:'L02',currentQuantity:2}
])
//导出确认按钮
const localExport = () => {
		let entozh = {
			code: "品号",
			projectCode: "项目编号",
			locationCode: '库位编号',
			currentQuantity: '数量'
		};
		exportExcel(modelList.value, entozh, "xlsx", "导出模板");
	}
//同步库位
const transferredILocation = ref('')
const onSameLocal = () => {
	list.value.forEach(item=>{
		item.transferredILocation = transferredILocation.value
	})
}
let scrollBody = null
const scrollTopDistance = ref(0); // 存储滚动距离
const showMaterial = ref(); // 存储滚动距离

onMounted(() => {
  // 确保组件已渲染，获取滚动容器  
  setTimeout(() => {
    nextTick(() => {
    scrollBody = showMaterial.value.$el.querySelector('.el-table__body-wrapper');
    console.log('scrollBody',scrollBody)
    if (scrollBody) {
      scrollBody.addEventListener('scroll', handleScroll);
    }
  });
  }, 3000);
  
});

watch(innerVisible, function (newVal) {
  setTimeout(() => {
    nextTick(() => {
    scrollBody = showMaterial.value.$el.querySelector('.el-table__body-wrapper');
    // console.log('scrollBody',scrollBody)
    if (scrollBody) {
      scrollBody.addEventListener('scroll', handleScroll);
    }
  });
  }, 3000);
});

onBeforeUnmount(() => {
  // 组件卸载时移除监听
  if (scrollBody) {
      scrollBody.removeEventListener('scroll', handleScroll);
    }
})
</script>

<style lang="less" scoped>
.assemble-edit-modal-content{
	height: 70vh;
	display: flex;
	flex-direction: column;
	.modal-content-top {
		padding: 0 16px 16px 16px ;
		flex-shrink: 0;
	}
	.modal-content-list{
		flex-grow: 1;
		height: 1px;
		overflow: auto;
		.list-padding{
			padding: 0 16px;
		}
	}
}
</style>